export default "__VITE_ASSET__5e046892__"